import { Component } from '@angular/core';
import { IzzyMacroEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Macros') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzymacro-form',
    templateUrl: './izzymacro.form.component.html'
})
export class IzzyMacroFormComponent extends BaseFormComponent {
    public record!: IzzyMacroEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'scopeOwnership', sectionName: 'Scope & Ownership', isExpanded: true },
            { sectionKey: 'macroDetailsActions', sectionName: 'Macro Details & Actions', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

